// Copyright (c) Jupyter Development Team.
// Copyright (c) Microsoft Corporation.
// Distributed under the terms of the Modified BSD License.
import { css } from '@microsoft/fast-element';
import { BaseFieldStyles } from '../styles/index.js';
/**
 * Styles for Text Field
 * @public
 */
export const textFieldStyles = (context, definition) => css `
  ${BaseFieldStyles}

  .start,
    .end {
    display: flex;
  }
`;
